import {HTMLAttributes, useEffect} from 'react';
import {requestContext} from '../../../../common/requestContext';
import {twMerge} from '../../../../common/twMerge';
import {ContentHomeTabWrapper} from '../../../../design-system/organisms/ContentHomeTabWrapper/ContentHomeTabWrapper';
import {ApiErrorBoundary} from '../../../../errors/ApiErrorBoundary.class';
import {ONLY_DATA_CONFIG} from '../../../../reactQuery/constant';
import {ReactQueryFetcher} from '../../../../reactQuery/ReactQueryFetcher';
import {
  useContentHomeNoticeQuery,
  useContentHomeOverviewQuery,
} from '../../../../wrapper/contentWrapper';
import {useContentHomeLastNotice} from '../hook/useContentHomeLastNotice';
import {ContentNoticeTabPcListContainer} from './ContentNoticeTabPcListContainer';

export interface ContentNoticeTabPcContainerProps
  extends HTMLAttributes<HTMLDivElement> {
  seriesId: number;
}

export function ContentNoticeTabPcContainer({
  seriesId,
  className,
  ...props
}: ContentNoticeTabPcContainerProps) {
  const {isMobile} = requestContext.requestInfo.display;
  const overview = useContentHomeOverviewQuery({seriesId}, ONLY_DATA_CONFIG)
    .data?.contentHomeOverview;

  const {visit} = useContentHomeLastNotice(seriesId);
  useEffect(() => {
    visit();
  }, [visit]);

  return (
    <ContentHomeTabWrapper
      isMobile={isMobile}
      displayAd={overview?.displayAd}
      saleState={overview?.content?.saleState}
      className={twMerge('flex flex-1 flex-col', className)}
      {...props}
    >
      <ApiErrorBoundary className="min-h-[656px] bg-theme-bg-surface-alt">
        <ReactQueryFetcher
          variables={{contentHomeNoticeInput: {seriesId, page: 0}}}
          reactQuery={useContentHomeNoticeQuery}
          loadingWrapperClassName="bg-theme-bg-surface-alt"
        >
          <ContentNoticeTabPcListContainer seriesId={seriesId} />
        </ReactQueryFetcher>
      </ApiErrorBoundary>
    </ContentHomeTabWrapper>
  );
}
